
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Button } from "../../App.styles";
import Modal from "../Modal";
import Textarea from "../Textarea";
import { useCreateAiPhotoMutation } from "./NubsUpload.state";
import { useSetRecoilState } from "recoil";
import { alertState } from "../AlertDisplay/AlertDisplay.state";
import Spinner from "../Spinner";
import { getErrorMessage } from "../../lib/error";

const ModalAiPhoto = ({ onDismiss, show, useQuery, taskId }) => {
    const { game_id } = useParams()
    const { t } = useTranslation()
    const setAlert = useSetRecoilState(alertState)
    const [modalValue, setModalValue] = useState({ prompt: '' })
    const handleDismiss = () => {
        // Clear the prompt value
        setModalValue({ prompt: '' })
        // Close the modal
        onDismiss()
    }
    const { loading, createAiPhoto } = useCreateAiPhotoMutation({
        game_id,
        taskId,
        useQuery,
        mutationOptions: {
            onSuccess: () => {
                handleDismiss()
            },
            onError: (error) => {
                const message = getErrorMessage(error, 'generating an AI photo')
                setAlert({ type: 'error', message, closable: true })
            },
        }
    })
    const onSave = async e => {
        e.preventDefault()
        const { prompt } = modalValue
        await createAiPhoto(prompt)
    }

    return show
        ? (
            <Modal onDismiss={handleDismiss} show={true} size="lg" className="modal--html form-clean">
                <div className="modal-title px-3 py-2">
                    <span dangerouslySetInnerHTML={{ __html: t('AI generated photo') }} />
                </div>
                <div className="modal-body px-3 pb-3">
                    <p dangerouslySetInnerHTML={{
                        __html: t(`Ask our AI to create a photo for your game/challenge. 
                    Tell it what to create. For example, "A photo of a dog wearing a sombrero."`)
                    }} />
                    <Textarea
                        name="prompt"
                        useQuery={() => [modalValue, setModalValue]}
                        mode="clean"
                        rows="5"
                        disabled={loading}
                    />
                </div>
                <div className="modal-footer">
                    {
                        !loading && (
                            <Button disabled={loading} className="btn--flat" data-dismiss="modal" onClick={handleDismiss} outline>
                                {t('Cancel')}
                            </Button>
                        )
                    }
                    <Button disabled={loading} className="btn--flat" data-dismiss="modal" onClick={onSave} color="primary">
                        {t('Generate Photo')} {loading ? <Spinner size="0.875rem" /> : null}
                    </Button>
                </div>
            </Modal>
        )
        : null
}

export default ModalAiPhoto
